export default "__VITE_ASSET__FJs6Ebsw__"